export var colorTypes = [{
  type: 'HEX',
  value: '#b2b2b2'
}, {
  type: 'HSB',
  value: 'hsb(0, 0%, 70%)'
}, {
  type: 'RGB',
  value: 'rgb(178, 178, 178)'
}, {
  type: 'HSL',
  value: 'hsl(0, 0%, 70%)'
}];